module.exports = __webpack_public_path__ + "img/PPMP11.6e0119a0.png";